<template>
  <div>
    登録されている地点グループはありません。
  </div>
</template>

<script>
export default {
  name: 'EmptyGroupList',
}
</script>

<style scoped></style>
